module.exports = __webpack_public_path__ + "img/case34-jpg.4ce35ae5.jpg";